export const dispatchCustomEvent = (eventName) => {
  const customEvent = new CustomEvent(eventName);
  document.dispatchEvent(customEvent);
};
